class StorageService {
  setSelectedStore(store) {
    localStorage.setItem("selected-store", JSON.stringify(store));
  }

  getSelectedStore() {
    const selected = localStorage.getItem("selected-store");
    return selected ? JSON.parse(selected) : null;
  }

  getSelectedStoreId() {
    const selected = localStorage.getItem("selected-store");
    if (!selected) return null;
    const parsed = JSON.parse(selected);
    return parsed.value;
  }

  removeSelectedStore() {
    localStorage.removeItem("selected-store");
  }
}

export default new StorageService();
